import React, { useState } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { InstallDatePicker } from './InstallDatePicker';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PROPERTY_TYPES = ['House / Townhouse', 'Brownstone', 'Apartment / Condo', 'Storefront / Business', 'Other'];
const EMPTY = { name: '', phone: '', email: '', address: '', property_type: '', notes: '' };
const FIELDS = [
  { name: 'name', type: 'text', placeholder: 'Your Name' },
  { name: 'phone', type: 'tel', placeholder: 'Phone Number' },
  { name: 'email', type: 'email', placeholder: 'Email Address' },
  { name: 'address', type: 'text', placeholder: 'Install Address' },
];

export const HolidayBookingForm = ({ onBooked }) => {
  const [form, setForm] = useState(EMPTY);
  const [installDate, setInstallDate] = useState(null);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const update = (name, value) => {
    setError('');
    setForm((prev) => ({ ...prev, [name]: value }));
  };
  const pickDate = (day) => {
    setError('');
    setInstallDate(day);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!installDate || !form.property_type) {
      setError('Please pick an install date and property type.');
      return;
    }
    setError('');
    setSubmitting(true);
    try {
      const { data } = await axios.post(`${API}/holiday-bookings`, { ...form, install_date: format(installDate, 'yyyy-MM-dd') });
      onBooked({ message: data.message, date: installDate });
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Please check your details and try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="holiday-booking-form">
      <div className="grid sm:grid-cols-2 gap-3">
        {FIELDS.map((f) => (
          <Input key={f.name} {...f} value={form[f.name]} onChange={(e) => update(f.name, e.target.value)} required data-testid={`booking-${f.name}-input`} />
        ))}
      </div>
      <InstallDatePicker value={installDate} onChange={pickDate} />
      <Select value={form.property_type} onValueChange={(v) => update('property_type', v)}>
        <SelectTrigger data-testid="booking-property-select"><SelectValue placeholder="Property type" /></SelectTrigger>
        <SelectContent className="z-[200]">
          {PROPERTY_TYPES.map((t) => <SelectItem key={t} value={t} data-testid={`booking-property-${t.split(' ')[0].toLowerCase()}`}>{t}</SelectItem>)}
        </SelectContent>
      </Select>
      <Textarea placeholder="Anything we should know? (roofline, trees, colors...)" rows={3} value={form.notes} onChange={(e) => update('notes', e.target.value)} data-testid="booking-notes-input" />
      {error && <p className="text-sm text-red-600" data-testid="booking-error">{error}</p>}
      <Button type="submit" disabled={submitting} className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-bold" data-testid="booking-submit-button">
        {submitting ? 'Sending...' : 'Request Install Date'}
      </Button>
    </form>
  );
};
